<template>
	<v-container fluid class="grey lighten-3">
		<v-container grid-list-lg>
			<v-row>
				<v-col class="display-2 font-weight-black text-xs-center black--text my-2">
					<h5>محصولات</h5>
				</v-col>
			</v-row>
			<v-row wrap class="good-ca rds">
				<v-col sm="6" md="4" v-for="(item, idx) in items" :key="idx">
					<v-hover>
						<v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" :to="item.link">
							<v-responsive>
								<v-img :src="item.image" height="300">
									<br />
									<v-container fill-height fluid>
										<v-layout fill-height>
											<v-flex xs12 align-end flexbox></v-flex>
										</v-layout>
									</v-container>
								</v-img>
							</v-responsive>
							<v-card-text>
								<div>
									<h2 class="font-weight-black black--text text-xs-right mb-1">{{ item.text }}</h2>
								</div>
								<v-divider></v-divider>
								<h3 class="font-weight-thin black--text text-xs-right mb-0">{{ item.desc }}</h3>
							</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn text color="grey darken-2" class="font-weight-thin black--text text-xs-center mb-0" :to="item.link">اطلاعات بیشتر</v-btn>
							</v-card-actions>
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
	export default {
		name: "GoodCards",
		data() {
			return {
				items: [
					{
						image: require("@/assets/img/home-retail-card.jpg"),
						text: "پازار فروشگاهی",
						desc: "ویژه ی کنترل و مدیریت فروشگاه ها",
						link: "/pazarplus",
						color: "green",
						onclick: "paleo",
						datacy: "plansPaleoBtn",
					},
					{
						image: require("@/assets/img/home-business-card.jpg"),
						text: "پازار شرکتی",
						desc: " ویژه شرکت های کوچک و متوسط",
						link: "/pazarplus",
						color: "green",
						onclick: "paleo",
						datacy: "plansPaleoBtn",
						price: "1000",
					},
					{
						image: require("@/assets/img/home-ind-card.jpg"),
						text: "پازار صنعتی",
						desc: "ویژه کارخانجات صنعتی",
						link: "./pazarsanati",
						color: "green",
						onclick: "paleo",
						datacy: "plansPaleoBtn",
					},
				],
			};
		},
		methods: {
			showRecipes(plan) {
				this.$store.dispatch("getRecipes", plan);
			},
		},
	};
</script>
<style>
	.text-block {
		background-color: rgba(0, 0, 0, 0.644);
	}
</style>
